import { useAuthStore } from '@/stores/auth'

/**
 * Persistent banner shown only on the dev server (`DEMO_MODE`, demo.claro.clinic).
 * Non-dismissable — always visible so nobody mistakes it for production.
 *
 * Since 2026-09-27 that server is the Claro DEV server, not a sales demo: it sits
 * behind Cloudflare Access (house network + named builders only) and the sales
 * team uses prod. No credentials here (CLA-1250).
 */
export function DemoBanner() {
  const demoMode = useAuthStore(s => s.demoMode)

  if (!demoMode) return null

  return (
    <div className="bg-warning-light border-b border-warning/25 px-4 py-1.5 flex items-center justify-center gap-3 shrink-0">
      <span className="text-[11px] font-semibold uppercase tracking-wider text-on-warning-soft">
        Dev Server
      </span>
      <span className="text-[11px] text-on-warning-soft">
        All data is synthetic. Resets nightly.
      </span>
    </div>
  )
}
